// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_mantine_root__56NS0","radio":"Radio_mantine_radio__FVkzJ","icon":"Radio_mantine_icon__p_Tfv"};